import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

interface TitleProps extends ThemeProps<ThemeInterface> {
    isCustomized?: boolean;
    isWide?: boolean;
}
export const Title = styled.h2<TitleProps>`
    color: ${(props: TitleProps) => props.theme.colors.charcoal100};
    font-family: 'ChronicleDisplay-Roman', ${(props: TitleProps) => props.theme.fonts.fontChronicleRoman};
    font-size: 1.375em;
    font-weight: normal;
    line-height: 1.5;
    margin: auto;
    max-width: 335px;
    text-align: center;

    ${(props: TitleProps) =>
        props.isCustomized &&
        fromBreakpoint[TABLET]`
            display: flex; 
            flex-direction: column; 
            justify-content: center; 
        `}

    ${(props: TitleProps) => fromBreakpoint[TABLET]`
        max-width: ${props.isWide ? 'none' : '320px'};
    `}
`;

export const MobileOnlyTitle = styled(Title)`
    display: block;
    ${forTablet`
        display: none;
    `}
`;
